import { gql } from '@apollo/client';
import {
  PAGE_CATEGORY_FRAGMENT,
  PAGE_CATEGORY_LIST_FRAGMENT,
} from '../fragments/category.web.graphql';
import { CategoryFragmentDoc } from '../../../../__generated__/queries-web';

/// GET CATEGORIES ////////////////////////////////////////////
export const GET_PAGE_CATEGORIES = gql`
  query GetPageCategories(
    $first: UnsignedInt!
    $where: CategoryFilterInput!
    $skip: UnsignedInt
  ) {
    categories(first: $first, where: $where, orderBy: title_ASC, skip: $skip) {
      ...CategoryList
      children(first: 1000, orderBy: title_ASC) {
        ...CategoryList
      }
    }
  }
  ${PAGE_CATEGORY_LIST_FRAGMENT}
`;

/// CATEGORY HISTORY ////////////////////////////////////////////
export const GET_PAGE_CATEGORY_HISTORY = gql`
  query GetPageCategoryHistory(
    $where: CategoryHistoryFilterInput
    $orderBy: [CategoryHistoryOrderingInput!]
  ) {
    categoryHistories(where: $where, orderBy: $orderBy, first: 999) {
      category {
        ...Category
      }
      createdAt
      id
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
    }
  }
  ${PAGE_CATEGORY_FRAGMENT}
`;

/// GET CATEGORY FOR EDIT ////////////////////////////////////////////
export const GET_CATEGORY_FOR_EDIT = gql`
  query GetCategoryForEdit($where: CategoryUniqueFilterInput!) {
    category(where: $where) {
      ...Category
      articleCategoryCount(where: { article: { status: Published } })
      articleChannelCount(where: { article: { status: Published } })
      articleEventCount(where: { article: { status: Published } })
      articleGuideCount(where: { article: { status: Published } })
    }
  }
  ${CategoryFragmentDoc}
`;
